import localeUtils from 'utils/LanguageLocale';
import ProductCompareToolItemEN from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/locales/ProductCompareToolItem_en_US';
import ProductCompareToolItemFR from 'components/ProductPage/ProductCompareTool/ProductCompareToolItem/locales/ProductCompareToolItem_fr_CA';

export const getText = localeUtils.getLocalisedDataFromResource(ProductCompareToolItemEN, ProductCompareToolItemFR);
